<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="12" lg="6">
        <b-form @submit="onSubmit" @reset="onReset">
          <b-form-group class="my-5"> Datos del usuario </b-form-group>
          <b-form-group id="password" label="Contraseña" label-for="password">
            <b-form-input
              id="password"
              :state="passwordValidate"
              v-model="user.password"
              type="password"
              required
              aria-describedby="input-live-help-1"
            ></b-form-input>
            <b-form-text id="input-live-help-1"
              >Ingresa 6 carácteres</b-form-text
            >
          </b-form-group>
          <b-form-group
            id="password_confirm"
            label="Contraseña"
            label-for="password"
          >
            <b-form-input
              id="password_confirm"
              :state="passwordValidate2"
              v-model="user.password_confirm"
              type="password"
              required
              aria-describedby="input-live-help-2"
            ></b-form-input>
            <b-form-text id="input-live-help-2"
              >Ingresa la misma contraseña</b-form-text
            >
          </b-form-group>
          <b-form-group class="text-center">
            <b-button
              class="btn text-light"
              type="submit"
              style="background: #0f182b; font-weight: bold"
              :disabled="isActiveButton"
            >
              {{ !isActiveButton ? "Cambiar Contraseña " : "Cargando" }}
            </b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
const axios = require("axios");
export default {
  name: "ChangePass",
  props: ["userData"],
  data() {
    return {
      email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
      password: /^.{6,20}$/,
      isActiveButton: false,
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      user: {
        password: "",
        password_confirm: "",
      },
    };
  },
  computed: {
    passwordValidate() {
      return this.password.test(this.user.password) ? true : false;
    },
    passwordValidate2() {
      return this.password.test(this.user.password_confirm) &&
        this.user.password_confirm === this.user.password
        ? true
        : false;
    },
  },

  methods: {
    onSubmit: function (evt) {
      evt.preventDefault();
      this.isActiveButton = true;
      if ($cookies.isKey("ctoken")) {
        axios({
          method: "POST",
          url: this.api_url + "/password/change",
          data: {
            email: this.userData.email,
            password: this.user.password,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + $cookies.get("ctoken"),
          },
        })
          .then((response) => {
            this.$snotify.success("Contraseña actualizada correctamente");
          })
          .catch((error) => {
            console.error(error);
            this.$snotify.warning("No se ha actualizado la contraseña");
          });
      } else {
        this.$snotify.info("No se ha podido actualizar el usuario. -- Err 002");
      }
    },
    onReset: function (evt) {
      evt.preventDefault();
      console.info("Reseteando");
    },
  },
};
</script>

<style>
</style>